<template>
  <section id="introView" class="intro-view align-center justify-center">
    <div class="row align-center justify-center mh">
      <div class="columns small-6 text-align-left">
        <h1 class="animate" v-html="data.title"></h1>
        <p class="animate" v-html="data.paragraph"></p>
        <div class="animate row btn-aligner">
          <ButtonElement
            class="justify-self-flex-start primary"
            type="button"
            :text="data.buttonText"
            :action="startQuiz"
          ></ButtonElement>
        </div>
      </div>
      <div class="columns small-6 align-left mobile-img" v-if="data.mobileImgSrc">
        <ImageElement className="home-image" :src="data.mobileImgSrc" :alt="data.imgAlt"></ImageElement>
      </div>
    </div>

    <!-- <div class="intro-design-bg design-bg"></div> -->
  </section>
</template>

<script>
import ButtonElement from '@/components/ButtonElement.vue'
import ImageElement from '@/components/ImageElement.vue'
import advanceQuestion from '@/shared/advanceQuestion'

export default {
  name: "IntroView",
  components: {
    ButtonElement,
    ImageElement
  },
  computed: {
    data() {
      return this.$store.state.intro
    }
  },
  methods: {
    startQuiz() {
      advanceQuestion(this.$store)
    }
  }
}
</script>

<style lang="scss">
// .design-bg {
//   background-image: url(../assets/images/intro.jpg);
//   background-size: 1440px 831px;
// }

#introView, .intro-view {
  padding: 40px 0;
  position: relative;
  width: 100%;

  @media print, screen and (min-width: 48em) {
    padding: 0;
  }

  .mh {
    height: 100%;
  }

  h1 {
    animation-delay: 1.5s;
    animation-name: fadeindown;
    font-family:"basic-sans";
    font-size: 9.896vw;
    font-weight: bold;
    line-height: 1.222;
    margin-bottom: 30px;
    margin-top: 0;
    max-width: 645px;
    transition: margin-top 0.3s;
    color: #fff;

    @media print, screen and (min-width: 48em) {
      font-size: 5.429vw;
      margin-top: 28px;
    }

    @media print, screen and (min-width: 1400px) {
      font-size: 70px;
    }
  }

  p {
    animation-delay: 1.25s;
    animation-name: fadeindown;
    font-family:"basic-sans";
    font-size: 18px;
    font-weight: normal;
    line-height: 1.333;
    margin-bottom: 20px;
    margin-top: 0;
    max-width: 660px;
    text-shadow: 1px 1px 10px rgba(79, 53, 155, 1),
                 -1px -1px 11px rgba(79, 53, 155, 1);
  }

  .btn-aligner {
    animation-delay: 1s;
    animation-name: fadeindown;
    margin: 0;
    max-width: 660px;
    transition: margin-left 0.3s;
    width: 100%;

    button {
      margin-left: 0;
    }
  }

  .mobile-img {
    display: block;
    margin-bottom: 40px;

    @media print, screen and (min-width: 48em) {
      display: none;
    }

    .home-image {
      animation-delay: 1s;
      animation-duration: 1.5s;
      animation-fill-mode: both;
      animation-name: fadein;
      margin-top: 50px;
      max-width: 100%;
      width: 100%;

      @media print, screen and (min-width: 48em) {
        margin-top: 0;
        width: 640px;
      }
    }
  }
}
</style>
